import { formatTimestamp } from '../lib/Formatter';
import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectEpisodePerformanceStatus } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, EpisodePerformance } from '../types';

export const LOAD_EPISODE_PERFORMANCE = 'LOAD_EPISODE_PERFORMANCE';

export const loadEpisodePerformance = (episodeId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'episodePerformance';
  const endpoint = `${PODCASTERS_SERVICE}/v0/episodes/${episodeId}/performance`;

  /* istanbul ignore next */
  if (selectEpisodePerformanceStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_EPISODE_PERFORMANCE_REQUEST'));

  try {
    const data: EpisodePerformance = await request.get(endpoint).then(toJSON);
    data.performanceData = data.samples.map((value, seconds) => ({
      timestamp: formatTimestamp(seconds),
      retention: Number(((value / data.max) * 100).toFixed(2)),
    }));

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_EPISODE_PERFORMANCE_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_EPISODE_PERFORMANCE_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
